import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './Text.css?raw';

export class propText extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    disabled: { type: Boolean, reflect: true },
    placeholder: { type: String },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
    leftIcons: { type: Object },
    rightIcons: { type: Object },
    type: { type: String },
    min: { type: Number },
    max: { type: Number },
    hideArrows: { type: Boolean },
  };
  constructor() {
    super();
    this.value = '';
    this.disabled = false;
    this.placeholder = 'auto';
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
    this.leftIcons = [];
    this.rightIcons = [];
    this.type = 'text';
    this.min = null;
    this.max = null;
    this.hideArrows = false;
    this._value = '';
  }
  get value() {
    return this._value;
  }
  set value(val) {
    const oldVal = this._value;
    this._value = val;
    this.requestUpdate('value', oldVal);
  }
  _onInput(e) {
    this._value = e;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(this.value || '');
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || '');
    }
    this.dispatchEvent(new CustomEvent('prop-value-input', { detail: { value: this.value || '' } }));
  }
  _onChange(e) {
    this._value = e;
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange.bind(this)(this.value || '');
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value || '');
    }
    this.dispatchEvent(new CustomEvent('prop-value-changed', { detail: { value: this.value || '' } }));
  }
  firstUpdated() {
    super.firstUpdated();
    this._createInput();
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    this._createInput();
  }
  _createInput() {
    let input = this.querySelector('rd-text-box');
    if (!input) {
      input = document.createElement('rd-text-box');
      input.slot = 'input';
      input.onInput = this._onInput.bind(this);
      input.onChange = this._onChange.bind(this);
      this.appendChild(input);
    }
    input.value = this.value || '';
    input.disabled = this.disabled || this._partialDisabled;
    input.placeholder = this.placeholder || '';
    input.style.width = '100%';
    input.style.height = '100%';
    input.showHover = true;
    input.showFocus = false;
    input.border = true;
    input.showActive = false;
    input.type = this.type || 'text';
    input.size = 'sm';
    input.min = this.min;
    input.max = this.max;
    input.hideArrows = this.hideArrows;
    if (this.leftIcons) {
      input.leftIcons = this.leftIcons;
    }
    if (this.rightIcons) {
      input.rightIcons = this.rightIcons;
    }

    return '';
  }

  _renderTextInput() {
    return html`
      <div class="text-input">
        <!-- <input type="text" placeholder="${this.placeholder || ''}" .value="${this.value}" ?disabled="${this.disabled || this._partialDisabled}" @input="${this._onInput}" @change="${this._onChange}" /> -->
        <!-- <rd-text-box .value="${this.value}" ?disabled="${this.disabled || this._partialDisabled}" @input="${this._onInput}" @change="${this._onChange}"></rd-text-box> -->
        <slot name="input"></slot>
      </div>
    `;
  }

  renderBody() {
    return html`<div class="option-container" tabindex="-1">${this._renderTextInput()}</div>`;
  }
}
if (!customElements.get('rd-prop-text')) {
  customElements.define('rd-prop-text', propText);
}
